module.exports = __webpack_public_path__ + "img/NoFault.2665d469.svg";